(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['$sessionStorage', '$localStorage',
                    function ($sessionStorage, $localStorage) {
                        $sessionStorage.proyectoId = null;
                        $sessionStorage.cliente = null;
                        $sessionStorage.Imagen = null;
                        $localStorage = null;
                    }
                ]
            }
        });
    }
})();
